import { analyticsManager } from './analyticsManager';
import { SelectProviderButtonSource } from './types';

export const trackSelectProviderButtonPressed = (
  buttonSource: SelectProviderButtonSource,
): void => {
  analyticsManager.track('vim_inline_button_clicked', { buttonSource });
};
